import _objectWithoutProperties from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
var _excluded = ["pageParam"],
    _excluded2 = ["pageParam"];
import { QueryObserver } from './queryObserver.esm.js';
import { infiniteQueryBehavior, hasNextPage, hasPreviousPage } from './infiniteQueryBehavior.esm.js';

var InfiniteQueryObserver = /*#__PURE__*/function (_QueryObserver) {
  _inherits(InfiniteQueryObserver, _QueryObserver);

  var _super = _createSuper(InfiniteQueryObserver);

  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function InfiniteQueryObserver(client, options) {
    _classCallCheck(this, InfiniteQueryObserver);

    return _super.call(this, client, options);
  }

  _createClass(InfiniteQueryObserver, [{
    key: "bindMethods",
    value: function bindMethods() {
      _get(_getPrototypeOf(InfiniteQueryObserver.prototype), "bindMethods", this).call(this);

      this.fetchNextPage = this.fetchNextPage.bind(this);
      this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    }
  }, {
    key: "setOptions",
    value: function setOptions(options, notifyOptions) {
      _get(_getPrototypeOf(InfiniteQueryObserver.prototype), "setOptions", this).call(this, _objectSpread(_objectSpread({}, options), {}, {
        behavior: infiniteQueryBehavior()
      }), notifyOptions);
    }
  }, {
    key: "getOptimisticResult",
    value: function getOptimisticResult(options) {
      options.behavior = infiniteQueryBehavior();
      return _get(_getPrototypeOf(InfiniteQueryObserver.prototype), "getOptimisticResult", this).call(this, options);
    }
  }, {
    key: "fetchNextPage",
    value: function fetchNextPage() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          pageParam = _ref.pageParam,
          options = _objectWithoutProperties(_ref, _excluded);

      return this.fetch(_objectSpread(_objectSpread({}, options), {}, {
        meta: {
          fetchMore: {
            direction: 'forward',
            pageParam: pageParam
          }
        }
      }));
    }
  }, {
    key: "fetchPreviousPage",
    value: function fetchPreviousPage() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          pageParam = _ref2.pageParam,
          options = _objectWithoutProperties(_ref2, _excluded2);

      return this.fetch(_objectSpread(_objectSpread({}, options), {}, {
        meta: {
          fetchMore: {
            direction: 'backward',
            pageParam: pageParam
          }
        }
      }));
    }
  }, {
    key: "createResult",
    value: function createResult(query, options) {
      var _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet, _state$data, _state$data2;

      var state = query.state;

      var result = _get(_getPrototypeOf(InfiniteQueryObserver.prototype), "createResult", this).call(this, query, options);

      var isFetching = result.isFetching,
          isRefetching = result.isRefetching;
      var isFetchingNextPage = isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward';
      var isFetchingPreviousPage = isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward';
      return _objectSpread(_objectSpread({}, result), {}, {
        fetchNextPage: this.fetchNextPage,
        fetchPreviousPage: this.fetchPreviousPage,
        hasNextPage: hasNextPage(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
        hasPreviousPage: hasPreviousPage(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
        isFetchingNextPage: isFetchingNextPage,
        isFetchingPreviousPage: isFetchingPreviousPage,
        isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
      });
    }
  }]);

  return InfiniteQueryObserver;
}(QueryObserver);

export { InfiniteQueryObserver };